export const PAGE_IN_POPUP_DATA_SET = 'PAGE_IN_POPUP:DATA:SET';
export const PAGE_IN_POPUP_STATE_CLEAR = 'PAGE_IN_POPUP:STATE:CLEAR';

export const setPageInPopupData = ({ path, url }) => ({
    type: PAGE_IN_POPUP_DATA_SET,
    payload: {
        path,
        url
    }
});
